<template>
  <div v-if="isOpen" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <h3 style="font-size:18px">¿Estás listo para conocer tu nuevo KIA {{ selectedCar }}?</h3>
      <img :src="selectedCarImage" alt="Car image" class="modal-car-img">

      <div class="form-group">
        <label for="date">Fecha:</label>
        <!--
        <input type="date" id="date" v-model="selectedDate" :min="minDate" class="form-input" required>
        -->
        <date-picker v-model="selectedDate" :disabled-date="fechaNoValida" format="DD/MM/YYYY" class="form-input" />
      </div>

      <div class="form-group">
        <label for="time">Hora:</label>
        <!--
        <input type="time" id="time" v-model="selectedTime"  required>
        -->
        <time-picker v-model="selectedTime" format="HH:mm" :minute-interval="10" :hour-range="[[10, 11], [14, 15]]"
          hide-disabled-items close-on-complete input-width="100%" class="form-input" />
      </div>

      <div class="modal-buttons">
        <button class="reserve-btn" @click="submitReservation">Confirmar Reserva</button>
      </div>
    </div>
  </div>
</template>

<script>
import iziToast from "izitoast";
import es from 'vue2-datepicker/locale/es'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import TimePicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  components: {
    DatePicker, TimePicker
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    selectedCar: {
      type: String,
      required: true
    },
    selectedCarImage: {
      type: String,
      required: true
    }

  },
  data() {
    //
    const hoy = new Date()
    //const mañana = new Date()
    //mañana.setDate(hoy.getDate() + 1)
    return {
      selectedDate: '',
      selectedTime: '',
      minDate: hoy,
    };
  },
  created() { },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    fechaNoValida(date) {      
      const dia = date.getDay();
      
      // Bloquear domingo y lunes
      if (dia === 1 || dia === 6 || dia === 0) return true

      // Bloquear fechas antes de minDate
      if (date <= this.minDate) return true

      return false;
    },
    submitReservation() {
      if (!this.selectedDate || !this.selectedTime) {
        iziToast.error({
          title: 'Error',
          message: 'Por favor, completa la fecha y la hora.',
          position: 'bottomCenter',
          timeout: 3000,
        });
        return;
      }

      if (!this.isValidTime()) {
        iziToast.error({
          title: 'Error',
          message: 'Por favor, selecciona una hora dentro del horario de atención.',
          position: 'bottomCenter',
          timeout: 3000,
        });
        return;
      }
      const fecha = this.getCurrentDate(this.selectedDate);
      this.$emit('submit', {
        car: this.selectedCar,
        date: fecha,
        time: this.selectedTime
      });

      this.$emit('open-client-modal');
      this.closeModal();
    },
    getCurrentDate(fecha) {
      //const today = new Date();
      //today.setDate(today.getDate() + 1);
      const year = fecha.getFullYear();
      const month = String(fecha.getMonth() + 1).padStart(2, '0');
      const day = String(fecha.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    isValidTime() {
      if (!this.selectedDate || !this.selectedTime) return false;

      const [hours, minutes] = this.selectedTime.split(":").map(Number)
      const selectedDateTime = new Date(this.selectedDate)
      selectedDateTime.setHours(hours, minutes, 0, 0)

      const dia = selectedDateTime.getDay()
      if (dia < 2 || dia > 5) {
        return false;
      }

      const totalMin = hours * 60 + minutes
      const rango1Inicio = 10 * 60
      const rango1Fin = 12 * 60
      const rango2Inicio = 14 * 60
      const rango2Fin = 16 * 60

      if (
        (totalMin >= rango1Inicio && totalMin < rango1Fin) ||
        (totalMin >= rango2Inicio && totalMin < rango2Fin)
      ) {
        const timezoneOffset = selectedDateTime.getTimezoneOffset();
        selectedDateTime.setMinutes(selectedDateTime.getMinutes() - timezoneOffset);

        localStorage.setItem('fecha', JSON.stringify(selectedDateTime));
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  text-align: center;
}

.modal-car-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  margin-bottom: 20px;
}

.reserve-btn {
  padding: 10px 20px;
  font-size: 1rem;
  cursor: pointer;
  border: none;
  transition: background-color 0.3s;
}

.reserve-btn {
  background-color: #05141f !important;
  color: white;
}

.reserve-btn:hover {
  background-color: #0a2a3f !important;
}

.form-group {
  margin-bottom: 15px;
  text-align: left;
}

.form-input {
  width: 100%;
  padding: 10px;
  font-size: 1.20rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #0066cc;
}
</style>
